import {
    SET_NOVELTIES
} from "@/views/novelties/store/types/types.js";

const mutations = {
    [SET_NOVELTIES]: (state, payload) => state.novelties = payload
}

export default mutations;